import GenreAddModal, { GenreAddModalReturnData } from 'features/MenuBook/components/GenreAddModal';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
function GenreAddModalDemo() {
  const [show, setShow] = useState(false);

  function handleClose() {
    setShow(false);
  }

  function handleShowModal() {
    setShow(true);
  }

  function handleReflect(returnData: GenreAddModalReturnData) {
    console.log('returnData', returnData);
  }

  return (
    <>
      <Button onClick={handleShowModal}>GenreAddModalDemo </Button>
      <GenreAddModal
        isShowModal={show}
        exceptGenreIds={[1, 3]}
        onClose={handleClose}
        onReflect={handleReflect}
      ></GenreAddModal>
    </>
  );
}
export default GenreAddModalDemo;
